import React from 'react';
import { Navigate } from 'react-router-dom';
import MasterBikeParts from '../components/MasterBikeParts';

const MasterBikePartsPage = ({ user }) => {
  if (!['superadmin', 'admin'].includes(user?.role)) {
    return <Navigate to="/services" replace />;
  }

  return <MasterBikeParts user={user} />;
};

export default MasterBikePartsPage;
